var map = {
	"./img_1.jpg": 76101,
	"./img_2.jpg": 67801,
	"./img_3.jpg": 43802,
	"./img_4.jpg": 32396,
	"./img_5.jpg": 32731,
	"./img_6.jpg": 61332,
	"./img_7.jpg": 79439
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 58640;